<template>
  <component
    :is="component"
    :changesFromFilter="changesFromFilter"
    @filter:config="(val) => $emit('filter:config', val)"
    @initial:active_filter="(val) => $emit('initial:active_filter', val)"
  ></component>
</template>

<script>
import Alerts from "@/views/Alerts";
import AlertV2 from "@/views/AlertV2";
import { mapGetters } from "vuex";

export default {
  components: {
    Alerts,
    AlertV2,
  },
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters(["isV2"]),
    component() {
      // return this.isV2 ? AlertV2 : Alerts;
      return AlertV2
    },
  },
};
</script>
